import customerProfile from '@/api/administration/customer-profile'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return customerProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  createCustomerProfile(context, data) {
    return customerProfile.store(data)
  },

  updateCustomerProfile(context, data) {
    return customerProfile.update(data)
  },

  deleteCustomerProfile(context, id) {
    return customerProfile.destroy(id)
  }
}
